import { TabPanel } from "@mui/lab";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import PageTabs from "../../common/PageTabs";
import ConfigurationsList from "./configurations/ConfigurationsList";
import ObjectsList from "./objects/ObjectsList";

const tabValues = ["objects", "configurations"] as const;

const DataModelPage = () => {
  usePageTitle("Data Model");

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  return (
    <>
      <GeneralPageHeader title="Data Model" hideBorderLine />
      <PageTabs tabs={tabValues} labels={["Objects", "Configurations"]} value={selectedTab} onChange={onTabChange}>
        <TabPanel value="objects" sx={{ height: "100%" }}>
          <ObjectsList />
        </TabPanel>
        <TabPanel value="configurations" sx={{ height: "100%" }}>
          <ConfigurationsList />
        </TabPanel>
      </PageTabs>
    </>
  );
};

export default DataModelPage;
